import { BookOpenRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

import { useGetUserManualLinks } from "state/useGetUserManualLinks";

import { DocumentLinkButton } from "./DocumentLinkButton";

/**
 * The client app only gets the user manual back from /usermanuallink.
 * The signup information document is admin-only.
 */
export const HeaderDocumentLinks = () => {
  const { t } = useTranslation();
  const { data: documentLinks, isLoading } = useGetUserManualLinks();

  return (
    <DocumentLinkButton
      icon={BookOpenRegular}
      label={t("hbh.userManual.label")}
      link={documentLinks?.[0]}
      isLoading={isLoading}
    />
  );
};
